import React from "react";
import HeroContent from "../../hero-content/HeroContent";
// import heroBgImg from "../../../images/mobile/hero-bg.png";
import heroBgImg from "../../../images/mobile/hero-img.png";

import "./hero.css";

function MobileHeroHome() {
  return (
    <section className="flex flex-col">
        <div className="mobile-hero-wrapper">
            <HeroContent isMobile />
        </div>
        <img src={heroBgImg} alt="mobile-hero-img" className="mobile-hero-img"/>
    </section>
  );
}

export default MobileHeroHome;
